
// import React, { useState, useEffect, useRef } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import { useTheme } from '../context/ThemeContext';
// import {
//   Mail, Lock, Eye, EyeOff, Sun, Moon, AlertCircle,
//   Target, BarChart2, Users, Zap, Home,
//   ArrowLeft, CheckCircle2, KeyRound, ShieldCheck,
//   RefreshCw, Send
// } from 'lucide-react';
// import toast from 'react-hot-toast';
// import api from '../utils/api';

// // views: 'login' | 'unverified' | 'otp_sent' | 'forgot' | 'reset_otp' | 'done'

// const PERKS = [
//   { icon: <Target size={18}/>,    text: 'Generate leads from 80+ business categories' },
//   { icon: <Zap size={18}/>,       text: 'Real-time business data — always fresh' },
//   { icon: <BarChart2 size={18}/>, text: 'Lead scoring + CRM pipeline built-in' },
//   { icon: <Users size={18}/>,     text: 'Full admin control for team management' },
// ];

// function OTPInput({ value, onChange }) {
//   const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
//   const digits = (value + '      ').slice(0, 6).split('');

//   const handleKey = (i, e) => {
//     if (e.key === 'Backspace') {
//       const next = value.slice(0, i) + value.slice(i + 1);
//       onChange(next);
//       if (i > 0) refs[i - 1].current?.focus();
//       return;
//     }
//     if (!/^\d$/.test(e.key)) return;
//     const next = value.slice(0, i) + e.key + value.slice(i + 1);
//     onChange(next.slice(0, 6));
//     if (i < 5) refs[i + 1].current?.focus();
//   };

//   const handlePaste = e => {
//     const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
//     onChange(pasted);
//     if (pasted.length >= 6) refs[5].current?.focus();
//     else refs[Math.min(pasted.length, 5)].current?.focus();
//     e.preventDefault();
//   };

//   return (
//     <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
//       {Array(6).fill(0).map((_, i) => (
//         <input key={i} ref={refs[i]}
//           type="text" inputMode="numeric" maxLength={1}
//           value={digits[i].trim()}
//           onKeyDown={e => handleKey(i, e)}
//           onPaste={handlePaste}
//           onChange={() => {}}
//           autoFocus={i === 0}
//           style={{
//             width: 44, height: 52, textAlign: 'center',
//             fontSize: 22, fontWeight: 800,
//             background: 'var(--bg3)',
//             border: `2px solid ${digits[i].trim() ? 'var(--accent)' : 'var(--border)'}`,
//             borderRadius: 10, color: 'var(--text)', outline: 'none',
//             transition: 'border-color .15s', fontFamily: 'monospace',
//           }}
//         />
//       ))}
//     </div>
//   );
// }

// export default function LoginPage() {
//   const navigate = useNavigate();
//   const { login } = useAuth();
//   const { theme, toggleTheme } = useTheme();

//   const [form, setForm]       = useState({ email: '', password: '' });
//   const [showPw, setShowPw]   = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError]     = useState('');
//   const [view, setView]       = useState('login');

//   // Unverified flow
//   const [unverifiedEmail, setUnverifiedEmail] = useState('');
//   const [unverifiedUserId, setUnverifiedUserId] = useState('');
//   const [sendingVerify, setSendingVerify]     = useState(false);
//   const [verifyOTP, setVerifyOTP]             = useState('');
//   const [verifyLoading, setVerifyLoading]     = useState(false);
//   const [verifyError, setVerifyError]         = useState('');
//   const [countdown, setCountdown]             = useState(0);

//   // Forgot password
//   const [fpEmail, setFpEmail]           = useState('');
//   const [fpUserId, setFpUserId]         = useState('');
//   const [fpLoading, setFpLoading]       = useState(false);
//   const [fpError, setFpError]           = useState('');
//   const [resetOTP, setResetOTP]         = useState('');
//   const [newPw, setNewPw]               = useState('');
//   const [confirmPw, setConfirmPw]       = useState('');
//   const [showNewPw, setShowNewPw]       = useState(false);
//   const [resetLoading, setResetLoading] = useState(false);
//   const [resetError, setResetError]     = useState('');

//   useEffect(() => {
//     if (countdown <= 0) return;
//     const t = setTimeout(() => setCountdown(c => c - 1), 1000);
//     return () => clearTimeout(t);
//   }, [countdown]);

//   // ── Login ─────────────────────────────────────────────────────────────────
//   const handleLogin = async e => {
//     e.preventDefault();
//     setError('');
//     if (!form.email.trim()) { setError('Please enter your email.'); return; }
//     if (!form.password)     { setError('Please enter your password.'); return; }
//     setLoading(true);
//     try {
//       const data = await login(form.email.trim(), form.password);
//       // Backend returns requiresVerification:true when email not verified
//       if (data?.requiresVerification) {
//         setUnverifiedEmail(data.user?.email || form.email.trim());
//         setUnverifiedUserId(data.userId || data.user?.id || '');
//         setView('unverified');
//         return;
//       }
//       toast.success('Welcome back! 🎉');
//       navigate('/dashboard');
//     } catch (err) {
//       // Show error inline — no page refresh
//       setError(err?.response?.data?.message || err?.message || 'Login failed. Please try again.');
//     } finally { setLoading(false); }
//   };

//   // ── Send OTP for email verification ──────────────────────────────────────
//   const sendVerificationOTP = async () => {
//     setSendingVerify(true);
//     setVerifyError('');
//     try {
//       await api.post('/auth/resend-verification', { userId: unverifiedUserId, email: unverifiedEmail });
//       toast.success('OTP sent! Check your inbox.');
//       setView('otp_sent');
//       setCountdown(60);
//     } catch (err) {
//       setVerifyError(err?.response?.data?.message || 'Failed to send OTP. Try again.');
//     } finally { setSendingVerify(false); }
//   };

//   // ── Verify OTP ────────────────────────────────────────────────────────────
//   const handleVerifyOTP = async e => {
//     e.preventDefault();
//     if (verifyOTP.trim().length < 6) { setVerifyError('Enter the complete 6-digit OTP.'); return; }
//     setVerifyLoading(true);
//     setVerifyError('');
//     try {
//       await api.post('/auth/verify-email', { userId: unverifiedUserId, otp: verifyOTP.trim() });
//       toast.success('Email verified! Signing you in…');
//       // Auto-login after verification
//       setTimeout(async () => {
//         try {
//           await login(unverifiedEmail, form.password);
//           navigate('/dashboard');
//         } catch {
//           setView('login');
//           setForm(f => ({ ...f, email: unverifiedEmail }));
//           toast('Please sign in now.');
//         }
//       }, 600);
//     } catch (err) {
//       setVerifyError(err?.response?.data?.message || 'Invalid OTP. Try again.');
//     } finally { setVerifyLoading(false); }
//   };

//   // ── Forgot password — send OTP ────────────────────────────────────────────
//   const handleSendResetOTP = async e => {
//     e.preventDefault();
//     setFpError('');
//     if (!fpEmail.trim() || !fpEmail.includes('@')) { setFpError('Enter a valid email address.'); return; }
//     setFpLoading(true);
//     try {
//       const r = await api.post('/auth/forgot-password', { email: fpEmail.trim().toLowerCase() });
//       setFpUserId(r.data.userId || '');
//       toast.success('OTP sent! Check your inbox.');
//       setView('reset_otp');
//       setCountdown(60);
//     } catch { setView('reset_otp'); setCountdown(60); }
//     finally { setFpLoading(false); }
//   };

//   // ── Forgot password — reset with OTP ─────────────────────────────────────
//   const handleResetPassword = async e => {
//     e.preventDefault();
//     setResetError('');
//     if (resetOTP.trim().length !== 6) { setResetError('Enter the 6-digit OTP.'); return; }
//     if (newPw.length < 6)             { setResetError('Password must be at least 6 characters.'); return; }
//     if (newPw !== confirmPw)          { setResetError("Passwords don't match."); return; }
//     setResetLoading(true);
//     try {
//       await api.post('/auth/reset-password', {
//         userId: fpUserId,
//         otp: resetOTP.trim(),
//         newPassword: newPw,
//       });
//       setView('done');
//       toast.success('Password reset successfully!');
//     } catch (err) {
//       setResetError(err?.response?.data?.message || 'Invalid OTP. Please try again.');
//     } finally { setResetLoading(false); }
//   };

//   const clearErrors = () => { setVerifyError(''); setFpError(''); setResetError(''); };

//   const BackBtn = ({ to, label = 'Back to sign in', onPress }) => (
//     <button onClick={() => { if (onPress) onPress(); else setView(to); clearErrors(); }}
//       style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', color: 'var(--text3)', fontSize: 13, cursor: 'pointer', marginBottom: 28, padding: 0 }}>
//       <ArrowLeft size={14}/> {label}
//     </button>
//   );

//   const LeftPanel = () => (
//     <div style={{ background: 'linear-gradient(135deg,var(--accent) 0%,var(--accent2) 60%,#831843 100%)', padding: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative', overflow: 'hidden' }}>
//       <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle at 20% 80%,rgba(255,255,255,.08) 0%,transparent 50%),radial-gradient(circle at 80% 20%,rgba(255,255,255,.06) 0%,transparent 50%)' }}/>
//       <div style={{ position: 'relative', zIndex: 1 }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 56 }}>
//           <div style={{ width: 42, height: 42, background: 'rgba(255,255,255,.2)', borderRadius: 11, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>📡</div>
//           <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800, color: '#fff' }}>LeadRadar</div>
//         </div>
//         <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 800, color: '#fff', marginBottom: 16, lineHeight: 1.2 }}>The #1 tool for<br/>sales prospecting</h2>
//         <p style={{ fontSize: 15, color: 'rgba(255,255,255,.8)', marginBottom: 40, lineHeight: 1.7 }}>Stop wasting hours on manual research. LeadRadar finds you qualified, contact-ready leads in seconds.</p>
//         <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
//           {PERKS.map((p, i) => (
//             <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 13, color: '#fff' }}>
//               <div style={{ width: 38, height: 38, background: 'rgba(255,255,255,.15)', borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{p.icon}</div>
//               <div style={{ fontSize: 14, fontWeight: 500 }}>{p.text}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div style={{ position: 'relative', zIndex: 1, background: 'rgba(255,255,255,.12)', borderRadius: 14, padding: '20px 22px', border: '1px solid rgba(255,255,255,.2)' }}>
//         <div style={{ display: 'flex', gap: 2, marginBottom: 10 }}>{Array(5).fill(0).map((_,i)=><span key={i} style={{ color:'#fbbf24', fontSize:14 }}>★</span>)}</div>
//         <p style={{ color: '#fff', fontSize: 14, lineHeight: 1.6, marginBottom: 12, fontStyle: 'italic' }}>"LeadRadar gave our team 300+ qualified leads in the first week. The lead scoring feature ensures we only call the most promising businesses."</p>
//         <div style={{ color: 'rgba(255,255,255,.7)', fontSize: 12.5 }}>Amit Sharma · VP Sales, TechCorp India</div>
//       </div>
//     </div>
//   );

//   const TopControls = () => (
//     <div style={{ position: 'absolute', top: 20, right: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
//       <Link to="/" style={{ width: 34, height: 34, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg3)', color: 'var(--text2)', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }} title="Home">
//         <Home size={15}/>
//       </Link>
//       <button className="theme-toggle" onClick={toggleTheme}>
//         {theme === 'dark' ? <Sun size={16}/> : <Moon size={16}/>}
//       </button>
//     </div>
//   );

//   const renderRight = () => {

//     // ── Done ────────────────────────────────────────────────────────────────
//     if (view === 'done') return (
//       <div style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
//         <div style={{ width: 72, height: 72, background: 'var(--green-bg)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
//           <CheckCircle2 size={34} style={{ color: 'var(--green)' }}/>
//         </div>
//         <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 800, marginBottom: 10 }}>Password Reset!</h1>
//         <p style={{ color: 'var(--text3)', fontSize: 14, lineHeight: 1.7, marginBottom: 28 }}>Your password has been updated. Sign in with your new password.</p>
//         <button className="btn btn-primary btn-full btn-lg"
//           onClick={() => { setView('login'); setForm(f => ({ ...f, email: fpEmail })); setResetOTP(''); setNewPw(''); setConfirmPw(''); }}>
//           Sign In Now →
//         </button>
//       </div>
//     );

//     // ── Reset OTP ────────────────────────────────────────────────────────────
//     if (view === 'reset_otp') return (
//       <div style={{ width: '100%', maxWidth: 420 }}>
//         <BackBtn to="forgot"/>
//         <div style={{ textAlign: 'center', marginBottom: 28 }}>
//           <div style={{ width: 52, height: 52, background: 'var(--accent-bg)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
//             <ShieldCheck size={24} style={{ color: 'var(--accent)' }}/>
//           </div>
//           <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 800, marginBottom: 6 }}>Enter Reset OTP</h1>
//           <p style={{ color: 'var(--text3)', fontSize: 13.5, lineHeight: 1.6 }}>OTP sent to <strong style={{ color: 'var(--text)' }}>{fpEmail}</strong></p>
//         </div>
//         {resetError && <div className="alert alert-error" style={{ marginBottom: 16 }}><AlertCircle size={14} style={{ flexShrink: 0 }}/> {resetError}</div>}
//         <form onSubmit={handleResetPassword} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
//           <div className="form-group">
//             <label className="form-label" style={{ textAlign: 'center', display: 'block', marginBottom: 10 }}>6-Digit OTP</label>
//             <OTPInput value={resetOTP} onChange={setResetOTP}/>
//           </div>
//           <div className="form-group">
//             <label className="form-label">New Password</label>
//             <div className="input-group">
//               <Lock size={14} className="input-icon"/>
//               <input className="input" type={showNewPw?'text':'password'} placeholder="Min 6 characters"
//                 style={{ paddingRight: 40 }} value={newPw} onChange={e => { setNewPw(e.target.value); setResetError(''); }}/>
//               <button type="button" className="input-icon-right" onClick={() => setShowNewPw(!showNewPw)}>
//                 {showNewPw ? <EyeOff size={14}/> : <Eye size={14}/>}
//               </button>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Confirm Password</label>
//             <div className="input-group">
//               <Lock size={14} className="input-icon"/>
//               <input className="input" type="password" placeholder="Repeat new password"
//                 value={confirmPw} onChange={e => { setConfirmPw(e.target.value); setResetError(''); }}/>
//             </div>
//             {confirmPw && <span style={{ fontSize: 11.5, marginTop: 3, color: newPw===confirmPw?'var(--green)':'var(--red)', display:'block' }}>{newPw===confirmPw?'✓ Match':'✗ No match'}</span>}
//           </div>
//           <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={resetLoading || resetOTP.length < 6}>
//             {resetLoading ? <><div className="spinner spinner-sm"/>&nbsp;Resetting…</> : 'Reset Password →'}
//           </button>
//           <div style={{ textAlign: 'center', fontSize: 13, color: 'var(--text3)' }}>
//             {countdown > 0
//               ? <span>Resend in {countdown}s</span>
//               : <button type="button" style={{ background: 'none', border: 'none', color: 'var(--accent)', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}
//                   onClick={() => { setView('forgot'); setResetOTP(''); }}>Resend OTP</button>
//             }
//           </div>
//         </form>
//       </div>
//     );

//     // ── Forgot password ───────────────────────────────────────────────────────
//     if (view === 'forgot') return (
//       <div style={{ width: '100%', maxWidth: 420 }}>
//         <BackBtn to="login"/>
//         <div style={{ marginBottom: 28 }}>
//           <div style={{ width: 52, height: 52, background: 'var(--accent-bg)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
//             <KeyRound size={24} style={{ color: 'var(--accent)' }}/>
//           </div>
//           <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 800, marginBottom: 8 }}>Forgot password?</h1>
//           <p style={{ color: 'var(--text3)', fontSize: 14, lineHeight: 1.6 }}>Enter your registered email and we'll send you a 6-digit OTP.</p>
//         </div>
//         {fpError && <div className="alert alert-error" style={{ marginBottom: 16 }}><AlertCircle size={14} style={{ flexShrink: 0 }}/> {fpError}</div>}
//         <form onSubmit={handleSendResetOTP} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
//           <div className="form-group">
//             <label className="form-label">Email Address</label>
//             <div className="input-group">
//               <Mail size={14} className="input-icon"/>
//               <input className="input" type="email" placeholder="you@company.com"
//                 value={fpEmail} onChange={e => { setFpEmail(e.target.value); setFpError(''); }} required autoFocus/>
//             </div>
//           </div>
//           <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={fpLoading}>
//             {fpLoading ? <><div className="spinner spinner-sm"/>&nbsp;Sending…</> : 'Send OTP →'}
//           </button>
//         </form>
//         <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text3)' }}>
//           Remember it?{' '}
//           <button style={{ background: 'none', border: 'none', color: 'var(--accent)', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}
//             onClick={() => setView('login')}>Sign in</button>
//         </p>
//       </div>
//     );

//     // ── OTP sent — enter code ─────────────────────────────────────────────────
//     if (view === 'otp_sent') return (
//       <div style={{ width: '100%', maxWidth: 420 }}>
//         <BackBtn to="unverified" label="Back"/>
//         <div style={{ background: 'var(--green-bg)', border: '1px solid var(--green)', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
//           <CheckCircle2 size={18} style={{ color: 'var(--green)', flexShrink: 0 }}/>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 13.5, color: 'var(--green)' }}>OTP sent!</div>
//             <div style={{ fontSize: 12.5, color: 'var(--text3)', marginTop: 2 }}>Check <strong>{unverifiedEmail}</strong> for the 6-digit code</div>
//           </div>
//         </div>
//         <div style={{ textAlign: 'center', marginBottom: 24 }}>
//           <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Enter Verification OTP</h1>
//           <p style={{ color: 'var(--text3)', fontSize: 13.5, lineHeight: 1.6 }}>Enter the 6-digit OTP sent to your email.</p>
//         </div>
//         {verifyError && <div className="alert alert-error" style={{ marginBottom: 16 }}><AlertCircle size={14} style={{ flexShrink: 0 }}/> {verifyError}</div>}
//         <form onSubmit={handleVerifyOTP} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
//           <div>
//             <label className="form-label" style={{ textAlign: 'center', display: 'block', marginBottom: 12 }}>Verification OTP</label>
//             <OTPInput value={verifyOTP} onChange={v => { setVerifyOTP(v); setVerifyError(''); }}/>
//           </div>
//           <button className="btn btn-primary btn-full btn-lg" type="submit"
//             disabled={verifyLoading || verifyOTP.trim().length < 6}>
//             {verifyLoading ? <><div className="spinner spinner-sm"/>&nbsp;Verifying…</> : '✓ Verify & Sign In'}
//           </button>
//         </form>
//         <div style={{ marginTop: 20, textAlign: 'center', fontSize: 13, color: 'var(--text3)' }}>
//           {countdown > 0
//             ? <span>Resend available in <strong>{countdown}s</strong></span>
//             : <button style={{ background: 'none', border: 'none', color: 'var(--accent)', fontWeight: 600, cursor: 'pointer', fontSize: 13, display: 'inline-flex', alignItems: 'center', gap: 5 }}
//                 onClick={sendVerificationOTP} disabled={sendingVerify}>
//                 {sendingVerify ? <><div className="spinner spinner-sm"/> Sending…</> : <><RefreshCw size={12}/> Resend OTP</>}
//               </button>
//           }
//         </div>
//       </div>
//     );

//     // ── Unverified ────────────────────────────────────────────────────────────
//     if (view === 'unverified') return (
//       <div style={{ width: '100%', maxWidth: 420 }}>
//         <BackBtn to="login" label="Use a different account"/>
//         <div style={{ background: '#fff7ed', border: '2px solid #f97316', borderRadius: 14, padding: '24px', marginBottom: 24, textAlign: 'center' }}>
//           <div style={{ fontSize: 40, marginBottom: 12 }}>📧</div>
//           <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 800, marginBottom: 8, color: '#9a3412' }}>Email Not Verified</h2>
//           <p style={{ fontSize: 14, color: '#c2410c', lineHeight: 1.6, margin: 0 }}>
//             Your account for <strong>{unverifiedEmail}</strong> exists but hasn't been verified yet.
//           </p>
//         </div>
//         <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 28 }}>
//           {[
//             { n:'1', text:'Click "Send Verification OTP" below' },
//             { n:'2', text:'Open the email and enter the 6-digit OTP' },
//             { n:'3', text:"You'll be signed in automatically ✓" },
//           ].map(s => (
//             <div key={s.n} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
//               <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'var(--accent)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, flexShrink: 0 }}>{s.n}</div>
//               <div style={{ fontSize: 13.5, color: 'var(--text2)', lineHeight: 1.5, paddingTop: 3 }}>{s.text}</div>
//             </div>
//           ))}
//         </div>
//         {verifyError && <div className="alert alert-error" style={{ marginBottom: 16 }}><AlertCircle size={14} style={{ flexShrink: 0 }}/> {verifyError}</div>}
//         <button className="btn btn-primary btn-full btn-lg" onClick={sendVerificationOTP} disabled={sendingVerify} style={{ marginBottom: 12 }}>
//           {sendingVerify ? <><div className="spinner spinner-sm"/>&nbsp;Sending…</> : <><Send size={15}/> Send Verification OTP</>}
//         </button>
//         <button className="btn btn-ghost btn-full" onClick={() => setView('otp_sent')} style={{ fontSize: 13.5 }}>
//           I already have the OTP →
//         </button>
//         <p style={{ textAlign: 'center', marginTop: 16, fontSize: 12.5, color: 'var(--text3)' }}>
//           Wrong email? <Link to="/register" style={{ color: 'var(--accent)', fontWeight: 600 }}>Register with a different one</Link>
//         </p>
//       </div>
//     );

//     // ── Login (default) ───────────────────────────────────────────────────────
//     return (
//       <div style={{ width: '100%', maxWidth: 420 }}>
//         <div style={{ marginBottom: 32 }}>
//           <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Welcome back</h1>
//           <p style={{ color: 'var(--text3)', fontSize: 14 }}>Sign in to your LeadRadar account</p>
//         </div>
//         {error && (
//           <div className="alert alert-error" style={{ marginBottom: 16, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
//             <AlertCircle size={16} style={{ flexShrink: 0, marginTop: 1 }}/> <span>{error}</span>
//           </div>
//         )}
//         <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
//           <div className="form-group">
//             <label className="form-label">Email Address</label>
//             <div className="input-group">
//               <Mail size={14} className="input-icon"/>
//               <input className="input" type="email" placeholder="you@company.com"
//                 value={form.email} onChange={e => { setForm({ ...form, email: e.target.value }); setError(''); }}
//                 required autoComplete="email"/>
//             </div>
//           </div>
//           <div className="form-group">
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
//               <label className="form-label" style={{ margin: 0 }}>Password</label>
//               <button type="button"
//                 style={{ background: 'none', border: 'none', color: 'var(--accent)', fontSize: 12.5, fontWeight: 600, cursor: 'pointer', padding: 0 }}
//                 onClick={() => { setFpEmail(form.email); setView('forgot'); setError(''); }}>
//                 Forgot password?
//               </button>
//             </div>
//             <div className="input-group">
//               <Lock size={14} className="input-icon"/>
//               <input className={`input${error ? ' input-error' : ''}`}
//                 type={showPw ? 'text' : 'password'} placeholder="Your password"
//                 style={{ paddingRight: 40 }} value={form.password}
//                 onChange={e => { setForm({ ...form, password: e.target.value }); setError(''); }}
//                 required autoComplete="current-password"/>
//               <button type="button" className="input-icon-right" onClick={() => setShowPw(!showPw)}>
//                 {showPw ? <EyeOff size={14}/> : <Eye size={14}/>}
//               </button>
//             </div>
//           </div>
//           <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading}>
//             {loading ? <><div className="spinner spinner-sm"/>&nbsp;Signing in…</> : 'Sign In →'}
//           </button>
//         </form>
//         <div className="divider" style={{ margin: '20px 0' }}>demo credentials</div>
//         <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 9, padding: '12px 14px', fontSize: 13, color: 'var(--text2)', cursor: 'pointer' }}
//           onClick={() => { setForm({ email: 'admin@leadradar.com', password: 'Admin@123' }); setError(''); }}
//           title="Click to autofill">
//           📧 <strong>admin@leadradar.com</strong> &nbsp;🔑 <strong>Admin@123</strong>
//           <span style={{ float: 'right', fontSize: 11, color: 'var(--text3)' }}>click to fill</span>
//         </div>
//         <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13.5, color: 'var(--text3)' }}>
//           Don't have an account? <Link to="/register" style={{ color: 'var(--accent)', fontWeight: 600 }}>Create one free →</Link>
//         </p>
//         <div style={{ textAlign: 'center', marginTop: 12 }}>
//           <Link to="/" style={{ fontSize: 13, color: 'var(--text3)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
//             <Home size={13}/> Back to Home
//           </Link>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div style={{ minHeight: '100vh', display: 'grid', gridTemplateColumns: '1fr 1fr', background: 'var(--bg)' }}>
//       <LeftPanel/>
//       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 48px', position: 'relative', overflowY: 'auto' }}>
//         <TopControls/>
//         {renderRight()}
//       </div>
//       <style>{`@media(max-width:768px){div[style*="gridTemplateColumns: '1fr 1fr'"]{grid-template-columns:1fr!important}div[style*="linear-gradient(135deg,var(--accent)"]{display:none!important}}`}</style>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import {
  Mail, Lock, Eye, EyeOff, Sun, Moon, AlertCircle,
  Target, BarChart2, Users, Zap, Home,
  ArrowLeft, CheckCircle2, KeyRound, ShieldCheck,
  RefreshCw, Send
} from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

const PERKS = [
  { icon: <Target size={18}/>,    text: 'Generate leads from 80+ business categories' },
  { icon: <Zap size={18}/>,       text: 'Real-time business data — always fresh' },
  { icon: <BarChart2 size={18}/>, text: 'Lead scoring + CRM pipeline built-in' },
  { icon: <Users size={18}/>,     text: 'Full admin control for team management' },
];

// ── OTPInput — outside component so it never remounts ─────────────────────
function OTPInput({ value, onChange }) {
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const digits = (value + '      ').slice(0, 6).split('');

  const handleKey = (i, e) => {
    if (e.key === 'Backspace') {
      onChange(value.slice(0, i) + value.slice(i + 1));
      if (i > 0) refs[i - 1].current?.focus();
      return;
    }
    if (!/^\d$/.test(e.key)) return;
    const next = value.slice(0, i) + e.key + value.slice(i + 1);
    onChange(next.slice(0, 6));
    if (i < 5) refs[i + 1].current?.focus();
  };

  const handlePaste = e => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    onChange(pasted);
    refs[Math.min(pasted.length, 5)].current?.focus();
    e.preventDefault();
  };

  return (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
      {Array(6).fill(0).map((_, i) => (
        <input key={i} ref={refs[i]}
          type="text" inputMode="numeric" maxLength={1}
          value={digits[i].trim()}
          onKeyDown={e => handleKey(i, e)}
          onPaste={handlePaste}
          onChange={() => {}}
          autoFocus={i === 0}
          style={{
            width: 'clamp(36px, 12vw, 48px)',
            height: 'clamp(44px, 14vw, 56px)',
            textAlign: 'center',
            fontSize: 'clamp(18px, 5vw, 24px)',
            fontWeight: 800,
            background: 'var(--bg3)',
            border: `2px solid ${digits[i].trim() ? 'var(--accent)' : 'var(--border)'}`,
            borderRadius: 10,
            color: 'var(--text)',
            outline: 'none',
            transition: 'border-color .15s',
            fontFamily: 'monospace',
          }}
        />
      ))}
    </div>
  );
}

// ── LeftPanel — outside component ─────────────────────────────────────────
function LeftPanel() {
  return (
    <div className="login-left-panel">
      <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(circle at 20% 80%,rgba(255,255,255,.08) 0%,transparent 50%),radial-gradient(circle at 80% 20%,rgba(255,255,255,.06) 0%,transparent 50%)' }}/>
      <div style={{ position:'relative', zIndex:1 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:48 }}>
          <div style={{ width:42, height:42, background:'rgba(255,255,255,.2)', borderRadius:11, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 }}>📡</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:800, color:'#fff' }}>LeadRadar</div>
        </div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(24px,3vw,36px)', fontWeight:800, color:'#fff', marginBottom:14, lineHeight:1.2 }}>The #1 tool for<br/>sales prospecting</h2>
        <p style={{ fontSize:15, color:'rgba(255,255,255,.8)', marginBottom:36, lineHeight:1.7 }}>Stop wasting hours on manual research. LeadRadar finds you qualified, contact-ready leads in seconds.</p>
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          {PERKS.map((p, i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:12, color:'#fff' }}>
              <div style={{ width:36, height:36, background:'rgba(255,255,255,.15)', borderRadius:9, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{p.icon}</div>
              <div style={{ fontSize:14, fontWeight:500 }}>{p.text}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ position:'relative', zIndex:1, background:'rgba(255,255,255,.12)', borderRadius:14, padding:'18px 20px', border:'1px solid rgba(255,255,255,.2)', marginTop:32 }}>
        <div style={{ display:'flex', gap:2, marginBottom:8 }}>{Array(5).fill(0).map((_,i)=><span key={i} style={{ color:'#fbbf24', fontSize:14 }}>★</span>)}</div>
        <p style={{ color:'#fff', fontSize:13.5, lineHeight:1.6, marginBottom:10, fontStyle:'italic' }}>"LeadRadar gave our team 300+ qualified leads in the first week."</p>
        <div style={{ color:'rgba(255,255,255,.7)', fontSize:12 }}>Amit Sharma · VP Sales, TechCorp India</div>
      </div>
    </div>
  );
}

// ── Main LoginPage ─────────────────────────────────────────────────────────
export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const [form, setForm]       = useState({ email: '', password: '' });
  const [showPw, setShowPw]   = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [view, setView]       = useState('login');

  const [unverifiedEmail, setUnverifiedEmail]   = useState('');
  const [unverifiedUserId, setUnverifiedUserId] = useState('');
  const [sendingVerify, setSendingVerify]       = useState(false);
  const [verifyOTP, setVerifyOTP]               = useState('');
  const [verifyLoading, setVerifyLoading]       = useState(false);
  const [verifyError, setVerifyError]           = useState('');
  const [countdown, setCountdown]               = useState(0);

  const [fpEmail, setFpEmail]           = useState('');
  const [fpUserId, setFpUserId]         = useState('');
  const [fpLoading, setFpLoading]       = useState(false);
  const [fpError, setFpError]           = useState('');
  const [resetOTP, setResetOTP]         = useState('');
  const [newPw, setNewPw]               = useState('');
  const [confirmPw, setConfirmPw]       = useState('');
  const [showNewPw, setShowNewPw]       = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError]     = useState('');

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const handleLogin = async e => {
    e.preventDefault(); e.stopPropagation();
    setError('');
    if (!form.email.trim()) { setError('Please enter your email.'); return; }
    if (!form.password)     { setError('Please enter your password.'); return; }
    setLoading(true);
    try {
      const data = await login(form.email.trim(), form.password);
      if (data?.requiresVerification) {
        setUnverifiedEmail(data.user?.email || form.email.trim());
        setUnverifiedUserId(data.userId || data.user?.id || '');
        setView('unverified');
        return;
      }
      toast.success('Welcome back! 🎉');
      navigate('/search');
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Login failed. Please try again.');
    } finally { setLoading(false); }
  };

  const sendVerificationOTP = async () => {
    setSendingVerify(true); setVerifyError('');
    try {
      await api.post('/auth/resend-verification', { userId: unverifiedUserId, email: unverifiedEmail });
      toast.success('OTP sent! Check your inbox.');
      setView('otp_sent'); setCountdown(60);
    } catch (err) {
      setVerifyError(err?.response?.data?.message || 'Failed to send OTP.');
    } finally { setSendingVerify(false); }
  };

  const handleVerifyOTP = async e => {
    e.preventDefault();
    if (verifyOTP.trim().length < 6) { setVerifyError('Enter the complete 6-digit OTP.'); return; }
    setVerifyLoading(true); setVerifyError('');
    try {
      await api.post('/auth/verify-email', { userId: unverifiedUserId, otp: verifyOTP.trim() });
      toast.success('Email verified! Signing you in…');
      setTimeout(async () => {
        try { await login(unverifiedEmail, form.password); navigate('/search'); }
        catch { setView('login'); setForm(f => ({ ...f, email: unverifiedEmail })); toast('Please sign in now.'); }
      }, 600);
    } catch (err) {
      setVerifyError(err?.response?.data?.message || 'Invalid OTP. Try again.');
    } finally { setVerifyLoading(false); }
  };

  const handleSendResetOTP = async e => {
    e.preventDefault(); setFpError('');
    if (!fpEmail.trim() || !fpEmail.includes('@')) { setFpError('Enter a valid email address.'); return; }
    setFpLoading(true);
    try {
      const r = await api.post('/auth/forgot-password', { email: fpEmail.trim().toLowerCase() });
      setFpUserId(r.data.userId || '');
      toast.success('OTP sent! Check your inbox.');
      setView('reset_otp'); setCountdown(60);
    } catch { setView('reset_otp'); setCountdown(60); }
    finally { setFpLoading(false); }
  };

  const handleResetPassword = async e => {
    e.preventDefault(); setResetError('');
    if (resetOTP.trim().length !== 6) { setResetError('Enter the 6-digit OTP.'); return; }
    if (newPw.length < 6)             { setResetError('Password must be at least 6 characters.'); return; }
    if (newPw !== confirmPw)          { setResetError("Passwords don't match."); return; }
    setResetLoading(true);
    try {
      await api.post('/auth/reset-password', { userId: fpUserId, otp: resetOTP.trim(), newPassword: newPw });
      setView('done'); toast.success('Password reset successfully!');
    } catch (err) {
      setResetError(err?.response?.data?.message || 'Invalid OTP. Please try again.');
    } finally { setResetLoading(false); }
  };

  const clearErrors = () => { setVerifyError(''); setFpError(''); setResetError(''); };

  const BackBtn = ({ to, label = 'Back to sign in', onPress }) => (
    <button type="button" onClick={() => { if (onPress) onPress(); else setView(to); clearErrors(); }}
      style={{ display:'flex', alignItems:'center', gap:6, background:'none', border:'none', color:'var(--text3)', fontSize:13, cursor:'pointer', marginBottom:24, padding:0 }}>
      <ArrowLeft size={14}/> {label}
    </button>
  );

  const renderRight = () => {

    // ── Done ──────────────────────────────────────────────────────────────
    if (view === 'done') return (
      <div style={{ width:'100%', maxWidth:420, textAlign:'center' }}>
        <div style={{ width:72, height:72, background:'var(--green-bg)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 24px' }}>
          <CheckCircle2 size={34} style={{ color:'var(--green)' }}/>
        </div>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(20px,5vw,26px)', fontWeight:800, marginBottom:10 }}>Password Reset!</h1>
        <p style={{ color:'var(--text3)', fontSize:14, lineHeight:1.7, marginBottom:28 }}>Your password has been updated. Sign in with your new password.</p>
        <button type="button" className="btn btn-primary btn-full btn-lg"
          onClick={() => { setView('login'); setForm(f => ({ ...f, email: fpEmail })); setResetOTP(''); setNewPw(''); setConfirmPw(''); }}>
          Sign In Now →
        </button>
      </div>
    );

    // ── Reset OTP ─────────────────────────────────────────────────────────
    if (view === 'reset_otp') return (
      <div style={{ width:'100%', maxWidth:420 }}>
        <BackBtn to="forgot"/>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <div style={{ width:52, height:52, background:'var(--accent-bg)', borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
            <ShieldCheck size={24} style={{ color:'var(--accent)' }}/>
          </div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(20px,5vw,24px)', fontWeight:800, marginBottom:6 }}>Enter Reset OTP</h1>
          <p style={{ color:'var(--text3)', fontSize:13.5, lineHeight:1.6 }}>OTP sent to <strong style={{ color:'var(--text)' }}>{fpEmail}</strong></p>
        </div>
        {resetError && <div className="alert alert-error" style={{ marginBottom:16 }}><AlertCircle size={14} style={{ flexShrink:0 }}/> {resetError}</div>}
        <form onSubmit={handleResetPassword} style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div className="form-group">
            <label className="form-label" style={{ textAlign:'center', display:'block', marginBottom:12 }}>6-Digit OTP</label>
            <OTPInput value={resetOTP} onChange={setResetOTP}/>
          </div>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <div className="input-group">
              <Lock size={14} className="input-icon"/>
              <input className="input" type={showNewPw?'text':'password'} placeholder="Min 6 characters"
                style={{ paddingRight:40 }} value={newPw} onChange={e => { setNewPw(e.target.value); setResetError(''); }}/>
              <button type="button" className="input-icon-right" onClick={() => setShowNewPw(p=>!p)}>
                {showNewPw ? <EyeOff size={14}/> : <Eye size={14}/>}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <div className="input-group">
              <Lock size={14} className="input-icon"/>
              <input className="input" type="password" placeholder="Repeat new password"
                value={confirmPw} onChange={e => { setConfirmPw(e.target.value); setResetError(''); }}/>
            </div>
            {confirmPw && <span style={{ fontSize:11.5, marginTop:3, color:newPw===confirmPw?'var(--green)':'var(--red)', display:'block' }}>{newPw===confirmPw?'✓ Match':'✗ No match'}</span>}
          </div>
          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={resetLoading || resetOTP.length < 6}>
            {resetLoading ? <><div className="spinner spinner-sm"/>&nbsp;Resetting…</> : 'Reset Password →'}
          </button>
          <div style={{ textAlign:'center', fontSize:13, color:'var(--text3)' }}>
            {countdown > 0
              ? <span>Resend in {countdown}s</span>
              : <button type="button" style={{ background:'none', border:'none', color:'var(--accent)', fontWeight:600, cursor:'pointer', fontSize:13 }}
                  onClick={() => { setView('forgot'); setResetOTP(''); }}>Resend OTP</button>}
          </div>
        </form>
      </div>
    );

    // ── Forgot password ───────────────────────────────────────────────────
    if (view === 'forgot') return (
      <div style={{ width:'100%', maxWidth:420 }}>
        <BackBtn to="login"/>
        <div style={{ marginBottom:28 }}>
          <div style={{ width:52, height:52, background:'var(--accent-bg)', borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:16 }}>
            <KeyRound size={24} style={{ color:'var(--accent)' }}/>
          </div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(20px,5vw,26px)', fontWeight:800, marginBottom:8 }}>Forgot password?</h1>
          <p style={{ color:'var(--text3)', fontSize:14, lineHeight:1.6 }}>Enter your registered email and we'll send you a 6-digit OTP.</p>
        </div>
        {fpError && <div className="alert alert-error" style={{ marginBottom:16 }}><AlertCircle size={14} style={{ flexShrink:0 }}/> {fpError}</div>}
        <form onSubmit={handleSendResetOTP} style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div className="input-group">
              <Mail size={14} className="input-icon"/>
              <input className="input" type="email" placeholder="you@company.com"
                value={fpEmail} onChange={e => { setFpEmail(e.target.value); setFpError(''); }} required autoFocus/>
            </div>
          </div>
          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={fpLoading}>
            {fpLoading ? <><div className="spinner spinner-sm"/>&nbsp;Sending…</> : 'Send OTP →'}
          </button>
        </form>
        <p style={{ textAlign:'center', marginTop:20, fontSize:13, color:'var(--text3)' }}>
          Remember it?{' '}
          <button type="button" style={{ background:'none', border:'none', color:'var(--accent)', fontWeight:600, cursor:'pointer', fontSize:13 }}
            onClick={() => setView('login')}>Sign in</button>
        </p>
      </div>
    );

    // ── OTP sent ──────────────────────────────────────────────────────────
    if (view === 'otp_sent') return (
      <div style={{ width:'100%', maxWidth:420 }}>
        <BackBtn to="unverified" label="Back"/>
        <div style={{ background:'var(--green-bg)', border:'1px solid var(--green)', borderRadius:10, padding:'12px 16px', display:'flex', alignItems:'center', gap:10, marginBottom:24 }}>
          <CheckCircle2 size={18} style={{ color:'var(--green)', flexShrink:0 }}/>
          <div>
            <div style={{ fontWeight:700, fontSize:13.5, color:'var(--green)' }}>OTP sent!</div>
            <div style={{ fontSize:12.5, color:'var(--text3)', marginTop:2 }}>Check <strong>{unverifiedEmail}</strong> for the 6-digit code</div>
          </div>
        </div>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(18px,5vw,22px)', fontWeight:800, marginBottom:8 }}>Enter Verification OTP</h1>
          <p style={{ color:'var(--text3)', fontSize:13.5, lineHeight:1.6 }}>Enter the 6-digit OTP sent to your email.</p>
        </div>
        {verifyError && <div className="alert alert-error" style={{ marginBottom:16 }}><AlertCircle size={14} style={{ flexShrink:0 }}/> {verifyError}</div>}
        <form onSubmit={handleVerifyOTP} style={{ display:'flex', flexDirection:'column', gap:20 }}>
          <div>
            <label className="form-label" style={{ textAlign:'center', display:'block', marginBottom:12 }}>Verification OTP</label>
            <OTPInput value={verifyOTP} onChange={v => { setVerifyOTP(v); setVerifyError(''); }}/>
          </div>
          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={verifyLoading || verifyOTP.trim().length < 6}>
            {verifyLoading ? <><div className="spinner spinner-sm"/>&nbsp;Verifying…</> : '✓ Verify & Sign In'}
          </button>
        </form>
        <div style={{ marginTop:20, textAlign:'center', fontSize:13, color:'var(--text3)' }}>
          {countdown > 0
            ? <span>Resend available in <strong>{countdown}s</strong></span>
            : <button type="button" style={{ background:'none', border:'none', color:'var(--accent)', fontWeight:600, cursor:'pointer', fontSize:13, display:'inline-flex', alignItems:'center', gap:5 }}
                onClick={sendVerificationOTP} disabled={sendingVerify}>
                {sendingVerify ? <><div className="spinner spinner-sm"/> Sending…</> : <><RefreshCw size={12}/> Resend OTP</>}
              </button>}
        </div>
      </div>
    );

    // ── Unverified ────────────────────────────────────────────────────────
    if (view === 'unverified') return (
      <div style={{ width:'100%', maxWidth:420 }}>
        <BackBtn to="login" label="Use a different account"/>
        <div style={{ background:'#fff7ed', border:'2px solid #f97316', borderRadius:14, padding:'20px', marginBottom:24, textAlign:'center' }}>
          <div style={{ fontSize:40, marginBottom:10 }}>📧</div>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(16px,4vw,20px)', fontWeight:800, marginBottom:8, color:'#9a3412' }}>Email Not Verified</h2>
          <p style={{ fontSize:13.5, color:'#c2410c', lineHeight:1.6, margin:0 }}>
            Your account for <strong>{unverifiedEmail}</strong> hasn't been verified yet.
          </p>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:24 }}>
          {[
            { n:'1', text:'Click "Send Verification OTP" below' },
            { n:'2', text:'Open the email and enter the 6-digit OTP' },
            { n:'3', text:"You'll be signed in automatically ✓" },
          ].map(s => (
            <div key={s.n} style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
              <div style={{ width:26, height:26, borderRadius:'50%', background:'var(--accent)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, flexShrink:0 }}>{s.n}</div>
              <div style={{ fontSize:13.5, color:'var(--text2)', lineHeight:1.5, paddingTop:3 }}>{s.text}</div>
            </div>
          ))}
        </div>
        {verifyError && <div className="alert alert-error" style={{ marginBottom:16 }}><AlertCircle size={14} style={{ flexShrink:0 }}/> {verifyError}</div>}
        <button type="button" className="btn btn-primary btn-full btn-lg" onClick={sendVerificationOTP} disabled={sendingVerify} style={{ marginBottom:12 }}>
          {sendingVerify ? <><div className="spinner spinner-sm"/>&nbsp;Sending…</> : <><Send size={15}/> Send Verification OTP</>}
        </button>
        <button type="button" className="btn btn-ghost btn-full" onClick={() => setView('otp_sent')} style={{ fontSize:13.5 }}>
          I already have the OTP →
        </button>
        <p style={{ textAlign:'center', marginTop:16, fontSize:12.5, color:'var(--text3)' }}>
          Wrong email? <Link to="/register" style={{ color:'var(--accent)', fontWeight:600 }}>Register with a different one</Link>
        </p>
      </div>
    );

    // ── Login ─────────────────────────────────────────────────────────────
    return (
      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ marginBottom:28 }}>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(22px,6vw,28px)', fontWeight:800, marginBottom:8 }}>Welcome back</h1>
          <p style={{ color:'var(--text3)', fontSize:14 }}>Sign in to your LeadRadar account</p>
        </div>
        {error && (
          <div className="alert alert-error" style={{ marginBottom:16, display:'flex', alignItems:'flex-start', gap:10 }}>
            <AlertCircle size={16} style={{ flexShrink:0, marginTop:1 }}/> <span>{error}</span>
          </div>
        )}
        <form onSubmit={handleLogin} style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div className="input-group">
              <Mail size={14} className="input-icon"/>
              <input className="input" type="email" placeholder="you@company.com"
                value={form.email} onChange={e => { setForm(f => ({ ...f, email:e.target.value })); setError(''); }}
                autoComplete="email"/>
            </div>
          </div>
          <div className="form-group">
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:5 }}>
              <label className="form-label" style={{ margin:0 }}>Password</label>
              <button type="button"
                style={{ background:'none', border:'none', color:'var(--accent)', fontSize:12.5, fontWeight:600, cursor:'pointer', padding:0 }}
                onClick={() => { setFpEmail(form.email); setView('forgot'); setError(''); }}>
                Forgot password?
              </button>
            </div>
            <div className="input-group">
              <Lock size={14} className="input-icon"/>
              <input className={`input${error ? ' input-error' : ''}`}
                type={showPw ? 'text' : 'password'} placeholder="Your password"
                style={{ paddingRight:40 }} value={form.password}
                onChange={e => { setForm(f => ({ ...f, password:e.target.value })); setError(''); }}
                autoComplete="current-password"/>
              <button type="button" className="input-icon-right" onClick={() => setShowPw(p=>!p)}>
                {showPw ? <EyeOff size={14}/> : <Eye size={14}/>}
              </button>
            </div>
          </div>
          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading}>
            {loading ? <><div className="spinner spinner-sm"/>&nbsp;Signing in…</> : 'Sign In →'}
          </button>
        </form>
        <div className="divider" style={{ margin:'20px 0' }}>demo credentials</div>
        {/* <div style={{ background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:9, padding:'12px 14px', fontSize:13, color:'var(--text2)', cursor:'pointer' }}
          onClick={() => { setForm({ email:'admin@leadradar.com', password:'Admin@123' }); setError(''); }}
          title="Click to autofill">
          📧 <strong>admin@leadradar.com</strong> &nbsp;🔑 <strong>Admin@123</strong>
          <span style={{ float:'right', fontSize:11, color:'var(--text3)' }}>click to fill</span>
        </div> */}
        <p style={{ textAlign:'center', marginTop:20, fontSize:13.5, color:'var(--text3)' }}>
          Don't have an account? <Link to="/register" style={{ color:'var(--accent)', fontWeight:600 }}>Create one free →</Link>
        </p>
        <div style={{ textAlign:'center', marginTop:12 }}>
          <Link to="/" style={{ fontSize:13, color:'var(--text3)', textDecoration:'none', display:'inline-flex', alignItems:'center', gap:5 }}>
            <Home size={13}/> Back to Home
          </Link>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{`
        /* ── Login page layout ── */
        .login-page {
          min-height: 100vh;
          display: grid;
          grid-template-columns: 1fr 1fr;
          background: var(--bg);
        }
        .login-left-panel {
          background: linear-gradient(135deg, var(--accent) 0%, var(--accent2) 60%, #831843 100%);
          padding: 48px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          overflow: hidden;
        }
        .login-right-panel {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 48px;
          position: relative;
          overflow-y: auto;
          min-height: 100vh;
        }
        .login-top-controls {
          position: absolute;
          top: 20px;
          right: 20px;
          display: flex;
          align-items: center;
          gap: 8px;
          z-index: 10;
        }

        /* ── Mobile: show logo bar at top, hide left panel ── */
        @media (max-width: 768px) {
          .login-page {
            grid-template-columns: 1fr;
          }
          .login-left-panel {
            display: none;
          }
          .login-right-panel {
            padding: 80px 24px 40px;
            justify-content: flex-start;
            min-height: 100vh;
          }
          .login-top-controls {
            top: 16px;
            right: 16px;
          }
          /* Show mobile logo bar */
          .login-mobile-header {
            display: flex !important;
          }
        }
        @media (min-width: 769px) {
          .login-mobile-header {
            display: none !important;
          }
        }

        /* ── Small phones ── */
        @media (max-width: 400px) {
          .login-right-panel {
            padding: 72px 16px 32px;
          }
        }
      `}</style>

      <div className="login-page">
        <LeftPanel/>

        <div className="login-right-panel">
          {/* Mobile logo header — only visible on mobile */}
          <div className="login-mobile-header" style={{
            display:'none',
            position:'fixed', top:0, left:0, right:0,
            height:56, background:'var(--surface)',
            borderBottom:'1px solid var(--border)',
            alignItems:'center', justifyContent:'center',
            zIndex:20, padding:'0 16px',
          }}>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <div style={{ width:32, height:32, background:'linear-gradient(135deg,var(--accent),var(--accent2))', borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16 }}>📡</div>
              <div style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:800 }}>LeadRadar</div>
            </div>
          </div>

          {/* Theme & Home controls */}
          <div className="login-top-controls">
            <Link to="/" style={{ width:34, height:34, borderRadius:8, border:'1px solid var(--border)', background:'var(--bg3)', color:'var(--text2)', display:'flex', alignItems:'center', justifyContent:'center', textDecoration:'none' }} title="Home">
              <Home size={15}/>
            </Link>
            <button className="theme-toggle" onClick={toggleTheme}>
              {theme === 'dark' ? <Sun size={16}/> : <Moon size={16}/>}
            </button>
          </div>

          {renderRight()}
        </div>
      </div>
    </>
  );
}